
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers/specialist/programmes/[programmeSlug]/units/[unitSlug]/lessons",
      function () {
        return require("private-next-pages/teachers/specialist/programmes/[programmeSlug]/units/[unitSlug]/lessons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers/specialist/programmes/[programmeSlug]/units/[unitSlug]/lessons"])
      });
    }
  